const PACKAGED_LOGOS: Record<string, string> = {
  'chatgpt.com': '/logos/chatgpt.png',
  'www.doubao.com': '/logos/doubao.png',
  'chat.deepseek.com': '/logos/deepseek.png',
  'gemini.google.com': '/logos/gemini.png',
  'notebooklm.google.com': '/logos/notebooklm.png',
};

export function getPackagedLogoUrl(websiteUrl: string) {
  try {
    const url = new URL(websiteUrl);
    if (!['http:', 'https:'].includes(url.protocol)) return '';
    return PACKAGED_LOGOS[url.hostname.toLowerCase()] || '';
  } catch {
    return '';
  }
}

export function getOfficialFaviconUrl(websiteUrl: string) {
  try {
    const url = new URL(websiteUrl);
    if (!['http:', 'https:'].includes(url.protocol)) return '';
    return `${url.origin}/favicon.ico`;
  } catch {
    return '';
  }
}
